import watcherLoginSaga from "../redux-store/sagas/login-sagas";
import watcherRegisterSaga from "../redux-store/sagas/register-saga";
import watcherCompanySaga from "../redux-store/sagas/add-company-saga";
import watcherUpdateUserSaga from "./sagas/users/update-user-saga";
import watcherGetUsersSaga from "./sagas/users/users-sagas";
import watcherAddUserSaga from "./sagas/users/add-user-saga";
import watcherGetProductCategoriesSaga from "./sagas/product-category/product-category.saga";
import watcherAddProductCategorySaga from "./sagas/product-category/add-product-category";
import watcherUpdateProductCategorySaga from "./sagas/product-category/update-product-category";
import watcherDeleteProductCategorySaga from "./sagas/product-category/delete-product-category";
import watcherAddProductSaga from "../redux-store/sagas/product/add-product.saga";
import watcherDeleteProduct from "../redux-store/sagas/product/delete-product";
import watcherUpdateProduct from "../redux-store/sagas/product/update-product.saga";
import watcherGetProductsSaga from "../redux-store/sagas/product/product-saga";
import watcherAddLocationSaga from "../redux-store/sagas/location/add-location.saga";
import watcherDeleteLocation from "../redux-store/sagas/location/delete-location-saga";
import watcherUpdateLocationSaga from "../redux-store/sagas/location/update-location-saga";
import watcherGetLocationsSaga from "../redux-store/sagas/location/location-saga";
import watcherGetUserLocationsSaga from "../redux-store/sagas/location/location-saga";
import watcherGetInventoriesSaga from "../redux-store/sagas/inventory/inventory-saga";
import watcherAddInventorySaga from "../redux-store/sagas/inventory/add-inventory-saga";
import watcherAddInventoryCorrectionSaga from "../redux-store/sagas/inventory/inventory-correction-saga";
import watcherGetInventoryCountSaga from "../redux-store/sagas/inventory/inventory-count-saga";
import watcherGetWareHouseTransferSaga from "../redux-store/sagas/inventory/warehouse-transfer-saga";
import watcherGetSalesProductSaga from "../redux-store/sagas/sales/sales-saga";
import watcherSaveOrderSaga from "../redux-store/sagas/sales/save-order-saga";
import watcherGetOrdersSaga from "./sagas/sales/orders-saga";
import watcherDeleteOrderSaga from "./sagas/sales/delete-order-saga";
import watcherGetOrderDetailsSaga from "./sagas/sales/order-details-saga";
import watcherGetPaymentSaga from "./sagas/payments/payement-saga";
import watcherAddPaymentSaga from "./sagas/payments/add-payment-saga";
import watcherGetPickUpStationSaga from "./sagas/pick-up-station/pick-up-stations-saga";
import watcherAddPickUpStationSaga from "./sagas/pick-up-station/add-pick-station-saga";
import watcherUpdatePickUpStationSaga from "./sagas/pick-up-station/update-pick-up-station-saga";
import watcherDeletePickUpStation from "./sagas/pick-up-station/delete-pick-up-station-saga";
import watcherGetOrderDeliverySaga from "./sagas/order-delivery/order-delivery-saga";
import watcherAddOrderDeliverySaga from "./sagas/order-delivery/add-order-delivery-saga";
import watcherUpdateOrderDeliverySaga from "./sagas/order-delivery/update-order-delivery-saga";
import watcherDeleteOrderDeliverySaga from "./sagas/order-delivery/delete-order-delivery-saga";
import watcherGetAccountSaga from "./sagas/account/account-saga";
import watcherAddAccountSaga from "./sagas/account/add-account-saga";
import watcherDeleteAccountSaga from "./sagas/account/delete-account-saga";
import watcherSaveOrderForCheckOutSaga from "./sagas/sales/save-order-for-checkout";
import watcherLoadPaymentSaga from "./sagas/payments/load-payment";
import watcherGetInventoryValuationSaga from "./sagas/inventory/inventory-valuation-saga";
import watcherGetProfitabilityReportSaga from "./sagas/inventory/profitability-saga";
import watcherAddRefundSaga from "./sagas/payments/add-refund";
import watcherGetSalesReport from "./sagas/inventory/sales-report-saga";
import watcherAddCustomerInfoSaga from "./sagas/users/add-customer-info-saga";
import watcherGetCustomerInfo from "./sagas/users/customer-info.saga";
import watcherGetRepaymentsSaga from "./sagas/payments/repayment-saga";
import watcherLoadCreditPaymentSaga from "./sagas/payments/credit-payments-saga";
import watcherAddCreditPaymentSaga from "./sagas/payments/add-credit-payment-saga";
import watcherAddRepayment from "./sagas/payments/add-repayment-saga";
import watcherAddCompanyCreditSaga from "./sagas/company-credit-saga";
import watcherAutoLoginSaga from "./sagas/auto-login-saga";
import watcherGetOnlinePaymentSaga from "./sagas/payments/online_payment";
import watcherLoadPaymentHistorySaga from "./sagas/payments/payment-history";
import watcherAddFulfilOrderSaga from "./sagas/payments/fulfilment-saga";
import watcherGetStorageTanksSaga from "./sagas/storage-tanks/storage-tanks-saga";
import watcherAddStorageTankSaga from "./sagas/storage-tanks/add-storage-tank-saga";
import watcherUpdateStorageTankSaga from "./sagas/storage-tanks/update-storage-tanks-saga";
import watcherDeleteStorageTankSaga from "./sagas/storage-tanks/delete-storage-tank-saga";
import watcherGetProductsSalesPriceSaga from "./sagas/product-sales-price/product-sales-price-saga";
import watcherAddProductPriceSaga from "./sagas/product-sales-price/add-product";
import watcherDeleteProductPrice from "./sagas/product-sales-price/delete-product";
import watcherGetLogisticsCostSaga from "./sagas/logistics-cost/logistics-cost";
import watcherDeleteLogisticsCostSaga from "./sagas/logistics-cost/delete-logistics-cost";
import watcherAddLogisticsSaga from "./sagas/logistics-cost/add-logistics";
import watcherGetSuppliersSaga from "./sagas/supplier/supplier";
import watcherAddSupplierSaga from "./sagas/supplier/add-supplier";
import watcherUpdateSupplierSaga from "./sagas/supplier/update-supplier";
import watcherDeleteSupplierSaga from "./sagas/supplier/delete-supplier";

export const UiSagas = [
  watcherLoadPaymentHistorySaga(),
  watcherAddFulfilOrderSaga(),
  watcherGetPaymentSaga(),
  watcherAutoLoginSaga(),
  watcherGetRepaymentsSaga(),
  watcherAddCompanyCreditSaga(),
  watcherAddPaymentSaga(),
  watcherAddRepayment(),
  watcherLoadCreditPaymentSaga(),
  watcherGetOnlinePaymentSaga(),
  watcherAddCreditPaymentSaga(),
  watcherLoginSaga(),
  watcherRegisterSaga(),
  watcherGetRepaymentsSaga(),
  watcherGetProfitabilityReportSaga(),
  watcherDeleteLogisticsCostSaga(),
  watcherGetSuppliersSaga(),
  watcherAddCustomerInfoSaga(),
  watcherAddLogisticsSaga(),
  watcherGetLogisticsCostSaga(),
  watcherAddSupplierSaga(),
  watcherUpdateSupplierSaga(),
  watcherDeleteSupplierSaga(),
  watcherGetCustomerInfo(),
  watcherCompanySaga(),
  watcherUpdateUserSaga(),
  watcherUpdateStorageTankSaga(),
  watcherDeleteStorageTankSaga(),
  watcherGetProductsSalesPriceSaga(),
  watcherAddProductPriceSaga(),
  watcherAddUserSaga(),
  watcherGetUsersSaga(),
  watcherAddStorageTankSaga(),
  watcherGetSalesReport(),
  watcherGetProductCategoriesSaga(),
  watcherAddProductCategorySaga(),
  watcherUpdateProductCategorySaga(),
  watcherDeleteProductCategorySaga(),
  watcherDeleteProductPrice(),
  watcherGetProductsSaga(),
  watcherAddProductSaga(),
  watcherDeleteProduct(),
  watcherUpdateProduct(),
  watcherAddLocationSaga(),
  watcherDeleteLocation(),
  watcherGetLocationsSaga(),
  watcherGetStorageTanksSaga(),
  watcherUpdateLocationSaga(),
  watcherGetUserLocationsSaga(),
  watcherAddInventorySaga(),
  watcherGetInventoriesSaga(),
  watcherAddInventoryCorrectionSaga(),
  watcherGetInventoryCountSaga(),
  watcherGetWareHouseTransferSaga(),
  watcherGetOrderDetailsSaga(),
  watcherGetSalesProductSaga(),
  watcherSaveOrderSaga(),
  watcherGetOrdersSaga(),
  watcherDeleteOrderSaga(),
  watcherGetInventoryValuationSaga(),
  watcherAddRefundSaga(),
  watcherGetPickUpStationSaga(),
  watcherAddPickUpStationSaga(),
  watcherUpdatePickUpStationSaga(),
  watcherDeletePickUpStation(),
  watcherGetOrderDeliverySaga(),
  watcherAddOrderDeliverySaga(),
  watcherUpdateOrderDeliverySaga(),
  watcherDeleteOrderDeliverySaga(),
  watcherGetAccountSaga(),
  watcherAddAccountSaga(),
  watcherDeleteAccountSaga(),
  watcherSaveOrderForCheckOutSaga(),
  watcherLoadPaymentSaga(),
];
